var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-03",
    clipPath: "url(#clip0_1056_15049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.99999 6.66707H6.99999M1 6.66707H1.55818C1.72124 6.66707 1.80277 6.66707 1.8795 6.64865C1.94752 6.63232 2.01255 6.60538 2.0722 6.56883C2.13948 6.5276 2.19713 6.46995 2.31243 6.35465L6.50001 2.16707C6.77615 1.89093 6.77615 1.44321 6.50001 1.16707C6.22387 0.890925 5.77615 0.890926 5.50001 1.16707L1.31242 5.35465C1.19712 5.46995 1.13947 5.5276 1.09824 5.59488C1.06169 5.65453 1.03475 5.71956 1.01842 5.78758C1 5.86431 1 5.94584 1 6.1089V6.66707Z",
    stroke: "#FF9900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1056_15049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit03);
export default __webpack_public_path__ + "static/media/edit-03.d80d2b363b1729c8952193b817df8e02.svg";
export { ForwardRef as ReactComponent };